import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import Button from '../../../../../incase-domain/components/button/Button';
import {selectedSlideIndexSelector} from '../../../../../store/selectors/slide.selectors';

function MobileStatusBar(): JSX.Element {
    const {t} = useTranslation();
    const selectedSlideIndex = useSelector(selectedSlideIndexSelector);

    return (
        <div className="c-slideInfo">
            <Button variant="soft" dynamicSize color="primary" size="md" disablePointerEvents className="c-slideInfo__tag">
                {selectedSlideIndex + 1}
            </Button>
            <div className="c-slideInfo__chip">
                <Button variant="ghost" dynamicSize size="md" leading="solar:clock-circle-linear" disablePointerEvents>
                    7:30
                </Button>
                <Button leading="solar:cup-outline" dynamicSize variant="ghost" size="md" disablePointerEvents>
                    {t('header.points', {count: 5})}
                </Button>
            </div>
        </div>
    );
}

export default MobileStatusBar;
